// extracted by mini-css-extract-plugin
export default {"indicatorsContainer":"MIJ2oVSlFGpOq31ngDM8"};